<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table 
                            :settings="tableConfig" 
                            :table-items="tableItems" 
                            @new-item="openModal" 
                            @load-items="getTableData" 
                            @row-click="openModal" 
                            @delete-items="deleteItems" 
                            ref="gofixTable">
                            <template slot="gofix_table:name" slot-scope="row">
                                {{ row.item.name ? row.item.name : "-" }}
                            </template>
                            <template slot="gofix_table:code" slot-scope="row">
                                {{ row.item.code ? row.item.code : "-" }}
                            </template>
                            <template slot="gofix_table:description" slot-scope="row">
                                {{ row.item.description ? row.item.description : "-" }}
                            </template>
                            <template slot="gofix_table:contract_name" slot-scope="row">
                                {{ row.item.contract_name ? row.item.contract_name : "-" }}
                            </template>
                        </gofix-table>
                    </gofix-card>
                    <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
                        <b-form class="pb-20">
                            <gofix-form-dropdown
                                    label="Client Contract"
                                    vLabel="contract_name"
                                    :filterable="false"
                                    :append-to-body="true"
                                    :required="true"
                                    :options="modal.options.contracts"
                                    @search="searchContract"
                                    v-model="modal.data.contract">
                            </gofix-form-dropdown>
                            <gofix-form-input label="Name" v-model="modal.data.name" required show-icon-required></gofix-form-input>
                            <gofix-form-input label="Code" v-model="modal.data.code"></gofix-form-input>
                            <gofix-form-input label="Description" v-model="modal.data.description"></gofix-form-input>
                        </b-form>
                        <b-button-group class="d-block text-right">
                            <gofix-button label="SAVE" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
                        </b-button-group>
                    </b-modal>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'

export default {
    name: 'vendor-linking',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['master_brands']));
        return {
            tableConfig: {
                name: 'master-brands',
                controls: {
                    create: this.$checkRole(this.$accessModule.master_brands, 'create'),
                    delete: this.$checkRole(this.$accessModule.master_brands, 'delete'),
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: false,
                sortColumn: "id",
                sortDirection: "desc",
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 100,
                        thStyle: "width: 100px",
                    },
                    {
                        key: 'contract_name',
                        label: 'Client Contract',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width: 200px",
                        sorting: true,
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width: 200px",
                        sorting: true,
                    },
                    {
                        key: 'code',
                        label: 'Code',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width: 200px",
                        sorting: true,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width: 300px",
                        sorting: true,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                    }
                ]
            },
            tableItems: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                data: {
                    id: 0,
                    name: null,
                    description: null,
                    code: null,
                    contract: null
                },
                options: {
                    contracts: []
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
        })
    },
    created() {
        this.getClientContract()
    },
    methods: {
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.text,
                    children: node.children
                }
            return {
                id: node.data.id,
                label: node.text,
                children: undefined
            }
        },
        /*-- Table callback --------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            tableRequest.isMaster = true;
            await this.$store.dispatch("MasterBrandController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the master brand", "danger");
                    reject();
                })
        },
        openModal(item) {
            let data = {
                id: item ? item.id : 0,
                name: item ? item.name : null,
                description: item ? item.description : null,
                code: item ? item.code : null,
                contract: item && item.contract_id ? { id: item.contract_id, contract_name: item.contract_name } : null
            }

            this.modal.data = Object.assign({
                id: 0,
                name: null,
                description: null,
                code: null,
                contract: null
            }, data)

            if(!data.id && this.ClientContractID && this.ClientContractID.id) {
                this.modal.data.contract = this.ClientContractID
            }

            this.modal.title = item ? 'Edit Brand' : 'Create Brand'
            this.modal.loading = false
            this.modal.open = true
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store.dispatch('MasterBrandController/deleteItems', ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'master_brand'));
                })
                .catch(err => {
                    reject();
                })
        },
        saveItem() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if (!this.modal.data.name) {
                    return this.$alertNotification("Name is a required field.", "danger");
                }

                if (this.modal.loading) return;
                this.modal.loading = true;

                let request = {
                    name: this.modal.data.name,
                    description: this.modal.data.description,
                    code: this.modal.data.code
                }

                if(this.modal.data.contract) request.contract_id = this.modal.data.contract.id;

                let api = 'createItem'
                if(this.modal.data.id) {
                    api = 'updateItem'
                    request.id = this.modal.data.id
                }
                
                this.$store.dispatch(`MasterBrandController/${api}`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2('adding', 'master_brand'));
                    })
                    .catch(error => {
                        this.modal.loading = false;
                        if(error.response && error.response.data.error && error.response.data.error.message) {
                            this.$alertNotification(error.response.data.error.message, "danger")
                        }
                    })
            }, 300);
        },
        async getClientContract(filter = null) {
            await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
            .then(response => {  
                this.modal.options.contracts = response.data; 
            }).catch(error => {
                console.log(error);
            })
        },
        searchContract(search, loading){
            this.modal.options.contracts = []
            loading(true);
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getClientContract({ contract_name: search });
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
    }
}
</script>